module.exports = __webpack_public_path__ + "img/cpu-chip-02.a5bd3def.svg";